import { useEffect } from "react";
import type { WebSocketListenerHandler } from "../../contexts/WebSocketContext";
import type { WebSocketChannel } from "../../types/WebSocketChannel";
import type { WebSocketMessage } from "../../types/WebSocketMessage";
import { useWebSocket } from "./useWebSocket";
import { useUuid } from "@huub-web/ui";

/**
 * Hook for listening for websocket messages.
 */
export const useWebSocketListener = <
  T extends WebSocketMessage = WebSocketMessage,
>(
  channel: WebSocketChannel,
  handler: WebSocketListenerHandler<T>,
) => {
  const id = useUuid();
  const { registerListener, deregisterListener } = useWebSocket();

  useEffect(() => {
    if (!id) {
      return;
    }
    registerListener<T>(channel, id, handler);

    return () => {
      deregisterListener(channel, id);
    };
  }, [id]);
};
